// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__25JOr","detailsBorder":"styles_detailsBorder__3mcZc"};